<fieldset class="grid" aria-label="Einstellungen zum Schuldtitel" data-test-id="aufgabe-schuldtitel-root">
	<div class="column">
		<mat-checkbox
			class="column focus-inwards-dark"
			color="primary"
			[formControl]="bodyControls.eintragung"
			data-test-id="eintragung-checkbox">
			Eintragung auf Schuldtitel vermerken
		</mat-checkbox>
		<mat-checkbox
			class="column focus-inwards-dark"
			color="primary"
			[formControl]="bodyControls.abschrift"
			data-test-id="abschrift-checkbox">
			Beglaubigte Abschrift des Titels z.d.A.
		</mat-checkbox>
		<mat-checkbox
			class="column focus-inwards-dark"
			color="primary"
			[formControl]="bodyControls.vollstreckungsunterlagen"
			data-test-id="vollstreckung-checkbox">
			Vollstreckungsunterlagen an Einsender / Gläubiger
		</mat-checkbox>
	</div>
	<schir-int-client-notiz-in-aufgabe-editor
		class="row note"
		[aufgabenTyp]="AufgabenTyp.LFPR_SCHULDTITEL"
		data-test-id="aufgabe-notiz" />
</fieldset>
